import React from 'react';
import '../../styles/ekyb.css';

const EKYBStepNav = ({ currentStep, completedSteps, micaRequired, onStepClick }) => {
  const steps = [
    { id: 1, label: 'Jurisdiction', description: 'Select registry' },
    { id: 2, label: 'Search', description: 'Entity identification' },
    { id: 3, label: 'Registry Data', description: 'Verify information' },
    { id: 4, label: 'UBO', description: 'Beneficial owners' },
    { id: 5, label: 'AML Screening', description: 'Compliance check' }
  ];

  // Conditionally add MiCA step if required
  if (micaRequired) {
    steps.push({ id: 6, label: 'MiCA Check', description: 'CASP register' });
  }

  // Always add report as final step
  const reportStepId = micaRequired ? 7 : 6;
  steps.push({ id: reportStepId, label: 'Report', description: 'Verification summary' });

  const isStepCompleted = (stepId) => completedSteps.includes(stepId);
  const isStepActive = (stepId) => stepId === currentStep;
  const isStepDisabled = (stepId) => stepId > currentStep && !isStepCompleted(stepId);

  const handleStepClick = (stepId) => {
    if (!isStepDisabled(stepId) && onStepClick) {
      onStepClick(stepId);
    }
  };

  return (
    <div className="ekyb-step-nav">
      <div className="ekyb-step-nav-header">
        <div className="ekyb-step-nav-title">VERIFICATION WORKFLOW</div>
        <div className="ekyb-step-nav-subtitle">eKYB Process</div>
      </div>
      <div className="ekyb-step-list">
        {steps.map((step) => {
          const completed = isStepCompleted(step.id);
          const active = isStepActive(step.id);
          const disabled = isStepDisabled(step.id);

          return (
            <div
              key={step.id}
              className={`ekyb-step-item ${active ? 'active' : ''} ${completed ? 'completed' : ''} ${disabled ? 'disabled' : ''}`}
              onClick={() => handleStepClick(step.id)}
            >
              <div className="ekyb-step-number">
                {completed ? '✓' : step.id}
              </div>
              <div className="ekyb-step-content">
                <div className="ekyb-step-label">{step.label}</div>
                <div className="ekyb-step-description">{step.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EKYBStepNav;
